module.exports = __webpack_public_path__ + "static/media/insurance.6f5be559.jpg";